const PaymentTransactionFilterConfig = [
  {
    key: 'transactionType',
    label: 'Rodzaj transakcji',
    type: 'dropdown',
    options: [
      { label: 'Wpłata', value: 'PAYMENT' },
      { label: 'Wypłata', value: 'REFUND' },
    ],
  },
  {
    key: 'confirmed',
    label: 'Potwierdzenie',
    type: 'dropdown',
    options: [
      { label: 'Potwierdzone', value: true },
      { label: 'Niepotwierdzone', value: false },
    ],
  },
  {
    key: 'paymentDate',
    label: 'Data tranzakcji',
    type: 'date-range',
    labelFrom: 'Data od',
    labelTo: 'Data do',
  },
];
export default PaymentTransactionFilterConfig;
